export const intialReportData = {
  show_timesheet_notes: true,
  show_employee_id: false,
  show_job_code: false,
  show_mileage: false,
  time_in_decimal: true,
  show_approved_times: false,
  include_inactive: false,
  include_premium_pay: false,
  // show_custom_fields: false,
};
